import React from 'react';
import imports from '@/routing/imports';
import Loadable from '@/common/lazy/Loadable';

const BetbookModuleLoader = Loadable({ loader: imports.betbook, exp: Exp => Exp.MatchBetbookPosts });

function BetbookPostsModule({ matchId, isResult }) {
    return <BetbookModuleLoader matchId={matchId} isResult={isResult} />;
}

export default BetbookPostsModule;
